import {
  ALLOWED_EXTENSIONS,
  DOC_STATUS_LABEL,
  MAX_FILE_BYTES,
  PROJECT_DOCUMENTS_LOCKED,
} from "./constants";

export const getErrorMessage = (err, fallback = "İşlem başarısız.") => {
  if (!err) return fallback;
  if (typeof err === "string") return err;
  return err.message || fallback;
};

export const isDocumentsLockedError = (err) =>
  err &&
  (err.code === PROJECT_DOCUMENTS_LOCKED ||
    err.message === PROJECT_DOCUMENTS_LOCKED);

/** DMS admin: yalnızca GET /dms/compliance/me → isAdmin */
export const resolveIsDmsAdmin = (compliance) =>
  Boolean(compliance && compliance.isAdmin === true);

export const statusLabel = (status) =>
  DOC_STATUS_LABEL[status] || status || "—";

export const statusColor = (status) => {
  switch (status) {
    case "Approved":
      return "success";
    case "Pending":
      return "warning";
    case "Rejected":
      return "danger";
    case "Missing":
    default:
      return "secondary";
  }
};

export const validateUploadFile = (file) => {
  if (!file) return "Dosya seçilmelidir.";
  if (file.size > MAX_FILE_BYTES) {
    return "Dosya boyutu en fazla 20 MB olabilir.";
  }
  const name = String(file.name || "");
  const ext = name.includes(".")
    ? name.split(".").pop().toLowerCase()
    : "";
  if (!ALLOWED_EXTENSIONS.includes(ext)) {
    return `İzinli uzantılar: ${ALLOWED_EXTENSIONS.join(", ")}`;
  }
  return null;
};

export const flattenLeaves = (nodes, acc = []) => {
  (nodes || []).forEach((node) => {
    if (node.canUpload || (!node.children || node.children.length === 0)) {
      if (!node.isRoot) acc.push(node);
    }
    if (node.children && node.children.length) {
      flattenLeaves(node.children, acc);
    }
  });
  return acc;
};

export const walkCategories = (nodes, visit) => {
  (nodes || []).forEach((node) => {
    visit(node);
    if (node.children && node.children.length) {
      walkCategories(node.children, visit);
    }
  });
};
